export const DisableGdsKey = 'DisableGdsBooking';
export const VccAllowedMccCodesKey = 'VCC_ALLOWED_MCC_CODES';
